import { createSlice } from "@reduxjs/toolkit";
import {
  getTaxesLookup,
} from "../services/taxesLookupService";

let initialState = {
  isLoading: false,
  data: [],
  pages: 0,
  errors: null
};

const taxesLookupSlice = createSlice({
  name: "taxesLookup",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getTaxesLookup.pending, (state) => {
      state.isLoading = true;
      state.errors = null;
    })
    builder.addCase(getTaxesLookup.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.data = (payload[0] && JSON.parse(payload[0].jsonData)) || [];
      state.errors = null;
    })
    builder.addCase(getTaxesLookup.rejected, (state) => {
      state.isLoading = false;
      state.errors = [{ msg: "something went wrong!" }];
    })
  }
});

export default taxesLookupSlice.reducer;